import { HttpInterceptor, HttpRequest, HttpErrorResponse, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ApiMessageService, MessageType } from '../core/api-message.service';

export class ErrorHandlerInterceptor implements HttpInterceptor {
    constructor(
        private oidcSecurityService: OidcSecurityService,
        protected apiMessageService: ApiMessageService
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap(
                (event: HttpEvent<any>) => {},
                (err: any) => {
                    if (err instanceof HttpErrorResponse) {
                        if (err.status === 401 && environment.oidc.enable === 'true') {
                            this.oidcSecurityService.logoffAndRevokeTokens().subscribe(() => {
                                console.log('Logout after 401');
                            });                        
                        }
                    }
                }
            )
        );
    }
}
